import { RegisterForm } from "@/components/auth";
import { useRegister } from "@/api/mutation";
import { RegisterDTO } from "@/api/types";

export const SignUp = () => {
  const { mutate, isPending } = useRegister();

  const register = async (credentials: RegisterDTO) => {
    try {
      mutate(credentials);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return <RegisterForm isPending={isPending} onSubmit={register} />;
};
